import { notificationConstants } from '../../constants';
import {
    IErrors,
    INotification,
    INotificationAction,
} from '../../interfaces';


interface INotificationState {
    notificationsMap: Map<number, INotification>,
    errors: IErrors;
}

/**
 * Bar chart description visibility reducer. Process actions and change application global state
 *
 * @param {Object} state Current application state
 * @param {Object} action Current action
 *
 * @return {Object}
 */
export function notification(state: INotificationState = {
    notificationsMap: new Map(),
    errors: {},
}, action: INotificationAction): INotificationState {

    switch (action.type) {

        case notificationConstants.LIST_NOTIFICATION_SUCCESS:
        case notificationConstants.MASK_ALL_AS_READ_NOTIFICATION_SUCCESS:

            return {
                notificationsMap: new Map(action.notifications.map(value => [value.id, value])),
                errors: {},
            };

        case notificationConstants.LIST_NOTIFICATION_FAILURE:
        case notificationConstants.MASK_ALL_AS_READ_NOTIFICATION_FAILURE:

            return {
                ...state,
                errors: action.errors,
            };

        case notificationConstants.UPDATE_COMMENT_NOTIFICATION_SUCCESS:
        case notificationConstants.MASK_AS_READ_NOTIFICATION_SUCCESS:

            return {
                ...state,
                notificationsMap: state.notificationsMap.set(action.markAsRead.id, action.markAsRead),
            };

        default:

            return state;
    }
}
